import React, { useCallback, useState } from 'react';
import { Button } from 'antd';
import ExpiresTimer from './ExpiresTimer';
import logo from '../../assets/images/company_logos/codehall_dark.png';
import { useDispatch, useSelector } from 'react-redux';
import { submitProject } from '../../store/actions/ProjectActions';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const IDEHeader = () => {
  const { assessment } = useSelector(state => state.project);
  const { meeting } = useSelector(state => state.assesmentRecording);
  const dispatch = useDispatch();
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation('project_container');

  const handleSubmit = useCallback(async () => {
    setIsSubmitting(true);
    try {
      await dispatch(submitProject(assessment.id, meeting?.id));
    } catch (error) {
      setIsSubmitting(false);
    }
  }, [assessment.id, meeting?.id, dispatch, history]);

  return (
    <div
      style={{
        width: '100%',
        height: '9vh',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px',
      }}
    >
      <img
        src={logo}
        alt="CodeHall"
        style={{ width: '200px' }}
      />
      <ExpiresTimer
        expiresAt={assessment.expiresAt}
        assessmentId={assessment.id}
        handleSubmit={handleSubmit}
      />
      <Button
        type="primary"
        size="large"
        style={{
          fontSize: '18px',
          fontWeight: '500',
          borderRadius: '2px',
          height: '50px',
          width: '180px',
        }}
        onClick={handleSubmit}
        loading={isSubmitting}
        disabled={isSubmitting}
      >
        {t('submit_project')}
      </Button>
    </div>
  );
};

export default IDEHeader;
